(() => {
  const SELECTORS = {
    section: '[data-ha-recommendations-row]',
    content: '[data-ha-recommendations-content]'
  };

  const initProductGrid = (section) => {
    if (
      window.HAProductGridV2 &&
      typeof window.HAProductGridV2.init === 'function'
    ) {
      window.HAProductGridV2.init(section);
    }
  };

  const fetchRecommendations = async (section) => {
    if (!section || section.dataset.haRecommendationsLoaded === 'true') return;

    const content = section.querySelector(SELECTORS.content);
    const url = content?.dataset.url;

    if (!content || !url) return;

    section.dataset.haRecommendationsLoaded = 'true';
    content.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const fetchedSection = html.getElementById(section.id);
      const fetchedContent = fetchedSection?.querySelector(SELECTORS.content);

      if (!fetchedContent) return;

      const nextHTML = fetchedContent.innerHTML.trim();

      if (!nextHTML) {
        content.innerHTML = '';
        return;
      }

      content.innerHTML = nextHTML;
      content.setAttribute('aria-busy', 'false');

      initProductGrid(section);
    } catch (error) {
      console.error('HA recommendations failed to load:', error);
    } finally {
      content.setAttribute('aria-busy', 'false');
    }
  };

  const initSection = (section) => {
    if (!section) return;

    initProductGrid(section);
    fetchRecommendations(section);
  };

  const init = (scope = document) => {
    scope.querySelectorAll(SELECTORS.section).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();